import {useAppDispatch, useAppSelector} from '@/hooks/redux';
import {setIsUtc} from '@/redux/slice/emissionSlice';
import {Switch} from 'antd';
import classNames from 'classnames';
import moment from 'moment';
import {memo, useEffect, useState} from 'react';

const TimeText = () => {
  const dispatch = useAppDispatch();
  const [text, setText] = useState('');
  const isUtc = useAppSelector((state) => state.emission.isUtc);
  useEffect(() => {
    const interval = setInterval(() => {
      setText(
        isUtc
          ? moment.utc().format('DD/MM HH:mm')
          : moment().format('DD/MM HH:mm')
      );
    }, 1000);
    return () => clearInterval(interval);
  }, [isUtc]);

  const handleSwitch = (checked: boolean) => {
    dispatch(setIsUtc(checked));
  };

  return (
    <div className="flex items-center gap-x-[16px] mr-[16px]  ">
      <div className="overflow-hidden text-[#FFF] text-ellipsis font-Geist text-[14px] font-[500] leading-[14px]">
        {text}
      </div>
      <div className="flex items-center gap-x-[6px]">
        <p
          className={classNames(
            'text-[#57534E] font-Geist text-[14px] font-[500] leading-[16px] tracking-[-0.28px]',
            {
              '!text-[#E7E5E4]': !isUtc
            }
          )}
        >
          LT
        </p>
        <Switch
          className="app-switch"
          checked={isUtc}
          onChange={handleSwitch}
          style={{backgroundColor: isUtc ? '#D9F99D' : undefined}}
        />
        <p
          className={classNames(
            'text-[#57534E] font-Geist text-[14px] font-[500] leading-[16px] tracking-[-0.28px]',
            {
              '!text-[#E7E5E4]': isUtc
            }
          )}
        >
          UTC
        </p>
      </div>
    </div>
  );
};

export default memo(TimeText);
